import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Accounts, Storage } from 'actions';
import {
  getHoldTotalMarketValue,
  hasNegativeWeight,
} from '../../utils/helpers';
import CashAnalyze from '../../components/CashAnalyze';

class OverviewCash extends Component {
  /*
    Creates a "Cash holding" in order to account for the amount of cash in the analysis
    The security_detail parameter is required for the "convertToTickersAndWeights" function in the utils/helpers.js file
  */
  getCash = (account) => {
    const cash = {
      account: 'Overview',
      account_id: 'Overview',
      currency: 'CAD',
      market_value: account.cash,
      name: 'Cash',
      security: 'CASH:MKT',
      ticker: 'CASH:MKT',
      security_detail: {
        exchange_symbol: 'CASH:MKT',
        ticker: 'CASH:MKT',
        long_name: 'Cash',
        unadjusted_closing_price: {
          CAD: 1,
          USD: 1,
        },
      },
    };
    const holdingsCash = account.holdings.concat(cash);
    return holdingsCash;
  };

  analyze = (holdings) => {
    const { dispatch, history, user_region } = this.props;
    const gicHoldings = holdings.filter((holding) => holding.gic_ticker);
    Storage.removeItem('pwpa-has-exclude-holding');

    return dispatch(
      Accounts.analyze(
        holdings,
        history,
        { user_institution: 'Overview; All Accounts' },
        gicHoldings,
        user_region
      )
    );
  };

  render() {
    const { user_region, overview, dispatch, pwpaExchangeRate, language } =
      this.props;
    const hasNegativeWeights = hasNegativeWeight(overview.holdings);
    const isNegativePort =
      overview &&
      getHoldTotalMarketValue(overview, pwpaExchangeRate, user_region) < 0;

    return (
      <CashAnalyze
        hasNegativeWeights={hasNegativeWeights}
        isNegativePort={isNegativePort}
        analyze={this.analyze}
        dispatch={dispatch}
        holdings={this.getCash(overview)}
        language={language}
      />
    );
  }
}

OverviewCash.propTypes = {
  overview: PropTypes.object,
  dispatch: PropTypes.func,
  history: PropTypes.object,
  user_region: PropTypes.string,
  pwpaExchangeRate: PropTypes.number,
  language: PropTypes.string,
};

OverviewCash.defaultProps = {
  overview: {},
  dispatch: () => {},
  history: {},
  user_region: 'CA',
  pwpaExchangeRate: 0,
  language: 'en',
};

export default connect((state) => ({
  overview: state.Accounts.overview,
  user_region: state.Storage.user_region,
  pwpaExchangeRate: state.Storage['pwpa-exchange-rate'],
  language: state.Storage.language,
}))(OverviewCash);
